import {Component} from "@angular/core";

@Component({
  selector: "blank",
  template: ``,
})
export class BlankComponent {
}



/** WEBPACK FOOTER **
 ** ./script/shared/blank/component.ts
 **/